import {delayHit, hitAlgolytics} from "@pg-mono/algolytics";

import {ViewType} from "../../../view_type/ViewType";
import {getTrackedSiteData} from "../tracked_utils/tracked_site";

const getHomeLinkAlgolytics = delayHit((payload) => hitAlgolytics("gethome_click", payload), 500);

export const getHomeLinkClick = (viewType: ViewType) => {
    const payload = {
        view_type: viewType,
        ...getTrackedSiteData()
    };
    getHomeLinkAlgolytics(payload);
};
